// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import $ from 'jquery'; 
import {ajaxPerso} from "../fnc.js"
import moment from 'moment';

const refConst = require("../constants.js").v

export default function (props){

	const [isPunchedIn, setIsPunchedIn] = useState(false);
	const [startTime, setStartTime] = useState(null);
	const [elapsedTime, setElapsedTime] = useState(0);
	const [notes, setNotes] = useState("");
	const [loading, setLoading] = useState(false);
	const intervalRef = useRef(null);

	// Get current user's account ID
	const getAccountId = () => {
		if (props.getUser && props.getUser()) {
			return props.getUser().id;
		}
		return null;
	};

	// Check current punch status on mount
	useEffect(() => {
		checkCurrentStatus();
		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, []);

	// Update timer when punched in
	useEffect(() => {
		if (isPunchedIn && startTime) {
			intervalRef.current = setInterval(() => {
				const now = moment();
				const start = moment(startTime);
				const diff = now.diff(start, 'seconds');
				setElapsedTime(diff);
			}, 1000);
		} else {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
		}

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, [isPunchedIn, startTime]);

	const checkCurrentStatus = () => {
		const accountId = getAccountId();
		if (!accountId) {
			console.warn("No account ID found");
			return;
		}

		ajaxPerso({
			"api": "account",
			"trigger": "getCurrentStatus",
			"idAccount": accountId
		}, (r) => {
			console.info('getCurrentStatus response:', r);
			if (r.success && r.res && r.res.length > 0) {
				const row = r.res[0];
				if (row.punch_type === "in") {
					setIsPunchedIn(true);
					// Prefer server epoch to avoid timezone misinterpretation
					if (row.punch_time_unix) {
						setStartTime(moment.unix(row.punch_time_unix).toISOString());
					} else {
						setStartTime(row.punch_time);
					}
					setNotes(row.notes || "");
				} else {
					setIsPunchedIn(false);
					setStartTime(null);
					setElapsedTime(0);
				}
			} else if (r.error) {
				console.warn('Error checking status:', r.error);
			}
		});
	};

	const handlePunch = () => {
		const accountId = getAccountId();
		if (!accountId) {
			props.info({error: "No account ID found"});
			return;
		}

		setLoading(true);
		
		if (isPunchedIn) {
			// Punch Out
			ajaxPerso({
				"api": "account",
				"trigger": "punchOut",
				"idAccount": accountId,
				"notes": notes
			}, (r) => {
				setLoading(false);
				console.info('punchOut response:', r);
				if (r.success) {
					setIsPunchedIn(false);
					setStartTime(null);
					setElapsedTime(0);
					setNotes("");
					props.info({success: "Successfully punched out!"});
				} else if (r.error) {
					// If state is stale (e.g. multiple tabs/devices), resync from server.
					if (String(r.error).includes("User is not currently punched in")) {
						checkCurrentStatus();
					}
					props.info({error: r.error});
				}
			});
		} else {
			// Punch In
			ajaxPerso({
				"api": "account",
				"trigger": "punchIn",
				"idAccount": accountId,
				"notes": notes
			}, (r) => {
				setLoading(false);
				console.info('punchIn response:', r);
				if (r.success) {
					setIsPunchedIn(true);
					// Immediately refresh from server to get authoritative time
					checkCurrentStatus();
					props.info({success: "Successfully punched in!"});
				} else if (r.error) {
					// If already punched in (race / another tab), resync from server.
					if (String(r.error).includes("already punched in")) {
						checkCurrentStatus();
					}
					props.info({error: r.error});
				}
			});
		}
	};

	const formatTime = (seconds) => {
		const hours = Math.floor(seconds / 3600);
		const minutes = Math.floor((seconds % 3600) / 60);
		const secs = seconds % 60;
		return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
	};


	return (
		<div className="punch-in-out-container" style={{
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			paddingTop: '10px',
			backgroundColor: 'var(--eio-bg-elevated)',
			borderRadius: '10px',
			maxWidth: '400px',
			boxShadow: '0 2px 10px var(--eio-shadow)',
			color: 'var(--eio-text)'
		}}>
			<h3 style={{color: 'var(--eio-text)'}}>Time Tracker</h3>
			
			{/* Timer Display */}
			{isPunchedIn && (
				<div style={{
					fontSize: '40px',
					fontWeight: 'bold',
					color: '#28a745',
					// marginBottom: '10px',
					fontFamily: 'monospace'
				}}>
					{formatTime(elapsedTime)}
				</div>
			)}

			{/* Big Round Button */}
			<button
				onClick={handlePunch}
				disabled={loading}
				style={{
					width: '90px',
					height: '90px',
					borderRadius: '50%',
					border: 'none',
					backgroundColor: isPunchedIn ? '#dc3545' : '#28a745',
					color: 'white',
					fontSize: '18px',
					fontWeight: 'bold',
					cursor: loading ? 'not-allowed' : 'pointer',
					boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
					transition: 'all 0.3s ease',
					outline: 'none',
					opacity: loading ? 0.6 : 1
				}}
				onMouseEnter={(e) => {
					if (!loading) {
						e.target.style.transform = 'scale(1.05)';
						e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
					}
				}}
				onMouseLeave={(e) => {
					e.target.style.transform = 'scale(1)';
					e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
				}}
			>
				{loading ? 'Loading...' : (isPunchedIn ? 'OUT' : 'IN')}
			</button>

			{/* Status Text */}
			<div style={{
				marginTop: '10px',
				marginBottom: '5px',
				fontSize: '16px',
				color: 'var(--eio-text-muted)',
				textAlign: 'center'
			}}>
				{isPunchedIn ? (
					<>
						<div>You are currently <strong style={{color: '#28a745'}}>clocked in</strong></div>
						<div style={{fontSize: '14px', marginTop: '5px'}}>
							Started at: {moment(startTime).format('h:mm A')}
						</div>
					</>
				) : (
					<div>You are currently <strong style={{color: '#dc3545'}}>clocked out</strong></div>
				)}
			</div>

			{/* Notes Input */}
			{/* <div style={{width: '100%', marginTop: '20px'}}>
				<label style={{
					display: 'block',
					marginBottom: '5px',
					fontSize: '14px',
					color: '#555'
				}}>
					Notes (optional):
				</label>
				<textarea
					value={notes}
					onChange={(e) => setNotes(e.target.value)}
					placeholder="Add notes about your work session..."
					style={{
						width: '100%',
						padding: '10px',
						borderRadius: '5px',
						border: '1px solid #ddd',
						fontSize: '14px',
						minHeight: '60px',
						resize: 'vertical',
						fontFamily: 'inherit'
					}}
				/>
			</div> */}

			{/* Additional Info */}
			{isPunchedIn && startTime && (
				<div style={{
					marginTop: '15px',
					padding: '10px',
					backgroundColor: 'var(--eio-bg-muted)',
					borderRadius: '5px',
					width: '100%',
					fontSize: '12px',
					color: 'var(--eio-text-muted)',
					border: '1px solid var(--eio-border)'
				}}>
					<strong>Today&apos;s Session</strong>
					<div>Start: {moment(startTime).format('MMMM D, YYYY h:mm A')}</div>
				</div>
			)}
		</div>
	);
}
